import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NewRecipeComponent } from './new-recipe.component';
import { DirectivesModule } from 'src/app/Directives/directives.module';

@NgModule({
  declarations: [NewRecipeComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    DirectivesModule,
  ],
  exports: [NewRecipeComponent],
})
export class NewRecipeModule {}
